<template>
    <div id="preview">
        <div class="head">
            <i class="back"
               @click="back()"></i>
            <p class="title">作业预览</p>
        </div>
        <div v-if="loading">
            <div class="nowork"
                 v-if="questions && !questions.length">
                <span class="icon-meiyoufabushijuan"></span>
                <p>没有作业数据</p>
            </div>
            <template v-else>
                <div class="wrap">
                    <div class="total">
                        <div>共{{num}}题</div>
                    </div>
                    <div class="exercises stu_dowork_line"
                         v-for="(data,index) in questions"
                         :key="index">
                        <div class="quest_title"
                             v-if="data.asks.length>1">
                            <span class="tit_num"
                                  v-if="data.number">{{data.number}}、</span>
                            <p class="title"
                               v-if="data.type!=8"><span v-html="data.content"></span></p>
                            <p class="title"
                               v-if="data.type==8 && data.article_title"><span v-html="data.article_title"></span></p>
                            <p class="title"
                               v-if="data.type==8"><span v-html="data.article_text"></span></p>

                            <div class="img-wrap"><img :src="data.image"
                                     v-if="data.image && data.image.url" /></div>
                        </div>
                        <div class="quest_con"
                             v-for="ask,inx in data.asks">
                            <!-- 选择题 -->
                            <div v-if="ask.type==1||ask.type==8||ask.type==7">
                                <div class="judgeicon"
                                     :class="[ask.user_result == '1'? 'dui' : 'cuo']"></div>
                                <choice :ask='ask'
                                        :type="ask.type"></choice>
                            </div>
                            <!-- 填空 -->
                            <div v-if='ask.type == 2'>
                                <div class="judgeicon"
                                     :class="[ask.user_result == '1'? 'dui' : 'cuo']"></div>
                                <blanks :ask='ask'
                                        :askLength='data.asks.length'
                                        :checked="true"
                                        :number="data.number"></blanks>
                            </div>
                            <!-- 主观题 -->
                            <div v-if='ask.type == 3'>
                                <div class="judgeicon"
                                     :class="[ask.user_result == '1'? 'dui' : 'cuo']"></div>
                                <!--<subjective :ask='data.asks' :index='inx' :question='ask' :askLength='data.asks.length'></subjective>-->
                            </div>
                            <!-- 连线题 -->
                            <div class="line"
                                 v-if="ask.type==4">
                                <div class="judgeicon"
                                     :class="[ask.user_result == '1'? 'dui' : 'cuo']"></div>
                                <lines :ask='ask'
                                       :sheet="ask.right_answer"
                                       :onlyshow='true'
                                       :result='1'></lines>
                            </div>
                            <!-- 排序题 -->
                            <div class="line"
                                 v-if="ask.type==5">
                                <div class="judgeicon"
                                     :class="[ask.user_result == '1'? 'dui' : 'cuo']"></div>
                                <makes :ask='ask'
                                       :is_answer="true"
                                       :type='ask.type'></makes>
                            </div>
                            <!-- 断句题 -->
                            <div v-if="ask.type==6">
                                <div class="judgeicon"
                                     :class="[ask.user_result == '1'? 'dui' : 'cuo']"></div>
                                <sentence :ask='ask'></sentence>
                            </div>
                        </div>
                    </div>
                </div>
            </template>
        </div>
        <template v-else>
            <loadingS></loadingS>
        </template>
    </div>
</template>

<script type="text/ecmascript-6">
import headers from 'COMPONENTS/base/header.vue'
import loadingS from 'COMPONENTS/base/tealoading.vue';
import choice from 'VIEWS/chinese/module/result_choose.vue'  //选择题
import blanks from 'VIEWS/chinese/module/result_fill.vue'  //填空题
import lines from 'VIEWS/chinese/module/result_line.vue';     //连线题
import sentence from 'VIEWS/chinese/module/result_sentence.vue';//断句题
import makes from 'VIEWS/chinese/module/result_make.vue';//排序题
export default {
    data () {
        return {
            loading: false,
            question: [],
            type: this.$route.params.testType,
            taskId: this.$route.params.taskid,
            hd_type: this.$route.query.hd_type,		//活动id
        }
    },

    methods: {
        back () {
            this.$router.go(-1)
        },
        preview () {
            let url = "", data = {};
            if (this.type == "qz") {
                url = API_URL_HD_API + '/qz2022/tea/question_preview';
                data = { "paper_id": this.taskId, "sid": 51 }

            } else if (this.type == "2022winter") {
                url = API_URL_HD_API + '/winter2022/tea/question_preview';
                data = { "paper_id": this.taskId, "sid": 51 }
            } else if (this.type == "2023winter" || this.type == "2024winter") {
                url = API_URL_HD_API + '/winter2023/tea/question_preview';
                data = { "paper_id": this.taskId, "sid": 51 }
            }
            else if (this.type == "qm") {
                url = API_URL_HD_API + '/qm2022_down/tea/question_preview';
                data = { "paper_id": this.taskId, "sid": 51 }
            }
            else if (this.type == "2023kxjc") {
                url = API_URL_HD_API + '/kxjc2023/tea/question_preview';
                data = { "paper_id": this.taskId, "sid": 51 }
            }
            else if (this.type == "2023jdjc") {
                url = API_URL_HD_API + '/common/tea/question_preview';
                data = { "paper_id": this.taskId, "sid": 51, "hd_type": 5 }
            }
            else if (this.hd_type) {
                url = API_URL_HD_API + '/common/tea/question_preview';
                data = { "paper_id": this.taskId, "sid": 51, "hd_type": this.hd_type }
            }
            else {
                url = API_URL_TASK_API + '/chinese/make/message/data';
                data = { "message_id": this.taskId, "type": 1 }
            }
            this.$http.post(url, data).then(res => {
                this.loading = true;
                if (res.data.response == 'ok') {
                    this.questions = res.data.data;
                    let num = 0
                    this.questions.forEach(d => {
                        num = num + d.asks.length
                    });
                    this.num = num
                }
            })
        }
    },
    created () {
        this.preview()
    },
    destroyed () {
    },
    components: {
        loadingS,
        headers,
        sentence,
        choice,
        blanks,
        lines,
        makes
    }
}
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
@import "./src/assets/scss/common/_mixin";
#preview {
    padding-top: 96px / $ppr;
}
.head {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 10;
    width: 100vw;
    height: 96px / $ppr;
    background: #5e89ef;

    .back {
        position: absolute;
        top: 0;
        left: 0;
        width: 76px / $ppr;
        height: 96px / $ppr;
        background: url(./img/choose_back.png) no-repeat center;
        background-size: 18px / $ppr 34px / $ppr;
    }

    .title {
        width: 100%;
        height: 96px / $ppr;
        line-height: 96px / $ppr;
        font-size: 34px / $ppr;
        color: #fff;
        text-align: center;
    }

    .preview {
        position: absolute;
        top: 0;
        height: 96px / $ppr;
        line-height: 96px / $ppr;
        right: 24px / $ppr;
        z-index: 10;
        font-size: 30px / $ppr;
        color: #fff;
    }
}

.wrap {
    .total {
        width: 100%;
        height: 2.4rem;
        line-height: 2.4rem;
        background-color: #fff;
        margin-bottom: 24px / $ppr;
        div {
            font-size: 30px / $ppr;
            font-weight: 600;
            color: #333;
            padding-left: 24px / $ppr;
        }
    }
}
.exercises {
    // font-family:Monospace;
    background-color: #fff;
    margin-bottom: 24px / $ppr;
}
.quest_title {
    padding: 25px / $ppr;
    line-height: 46px / $ppr;
    font-size: 30px / $ppr;
    color: #333;
    border-bottom: 1px / $ppr solid #e8e8e8;
    background: #fff;
}
.nowork {
    color: $c-light;
    text-align: center;
    margin-top: 400px / $ppr;
    span {
        display: inline-block;
        color: $c-litgray;
        font-size: 130px / $ppr;
        margin-bottom: 36px / $ppr;
    }
}
.checked {
    color: #66cc22 !important;
    .spot {
        background-color: #66cc22 !important;
        border: 1px / $ppr solid #66cc22 !important;
        color: #fff;
    }
}
.question .option:last-child {
    border: 0 !important;
}
.quest_con /deep/ .choose {
    margin-top: 0 !important;
}
</style>

